import React, { Fragment, useEffect, useState } from "react";
import "../../assets/css/sap-master/sap-master.css";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { Button, DialogActions, Grid, InputAdornment } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";
import TextFiealdInput from "../components/textFiald";
import {
  addGroupDataData,
  clearGroupDataData,
} from "../../redux/sap-master/group-master-active-data-reducer";
import {
  business_channel_is_first,
  list_business_channel,
} from "../../redux/prefered-master/business-channel-list";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import AutoComplete from "../components/autocomplete-input";

import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import {
  add_business_channel,
  add_business_channel_api_complete,
  add_business_channel_isSuccess,
} from "../../redux/prefered-master/add-business-channel";
import {
  edit_business_channel,
  edit_business_channel_api_complete,
  edit_business_channel_isSuccess,
} from "../../redux/prefered-master/edit-business-channel";
import { list_branch_master } from "../../redux/prefered-master/list-branch-master";
import CompletePopup from "../components/response-pop-up";
import { useCommonContext } from "../../Utils/commonContext";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";

const GroupMaster = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const generalSettingList = useSelector((state: any) => state.GeneralSetting);
  const [responsePopup, setResponsePopup] = useState<boolean>(false);
  const [responseEdit, setResponseEdit] = useState<boolean>(false);
  const editBusinessChannel = useSelector(
    (state: any) => state.EditBusinessBhannel
  );
  const addBusinessChannel = useSelector(
    (state: any) => state.AddBusinessBhannel
  );
  const [isEdit, setEdit] = useState<boolean>(false);
  const [editData, setEditData] = useState<{
    costcenter: string;
    name: string;
    dimension: string;
    active: boolean;
    branch: string;
    type: string;
    validfrom: string;
    sequenceno: string;
  }>({
    costcenter: "",
    name: "",
    dimension: "",
    type: "",
    active: true,
    branch: "",
    validfrom: "",
    sequenceno: "",
  });
  const [activePartner, setActivePartner] = React.useState<null | number>(0);
  const [search, setSearch] = useState<string>("");
  const activeDatas = useSelector((state: any) => state.GroupMasterActiveData);
  const activeData = activeDatas.data;
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();

  const business_channel_data = useSelector(
    (state: any) => state.BusinessChannelList
  );
  const branch_master_data = useSelector(
    (state: any) => state.ListBranchMaster
  );
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
  };
  // useEffect

  const validationSchema = Yup.object().shape({
    costcenter: Yup.string()

      .max(4, "maximum  4 character")
      .required(" Required"),
    name: Yup.string().required("Required"),
    dimension: Yup.string().required("Required"),
    type: Yup.string().required("Required"),
    branch: Yup.string().required("Required"),
    validfrom: Yup.string().required("Required"),
    sequenceno: Yup.string()
      .matches(/^[0-9]+$/, "Must be only digits")

      .max(4, "maximum  4 character")
      .required("Required"),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      costcenter: isEdit ? editData.costcenter : "",
      name: isEdit ? editData.name : "",
      active: isEdit ? editData.active : true,
      dimension: isEdit ? editData.dimension : "",
      type: isEdit ? editData.type : "",
      branch: isEdit ? editData.branch : "",
      validfrom: isEdit ? editData.validfrom.substring(0, 10) : "",
      sequenceno: isEdit ? editData.sequenceno : "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submit(values);
    },
  });
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    resetForm,
    errors,
  } = formik;
  const submit = (a: any) => {
    if (!isEdit) {
      const data = {
        costcenter: a.costcenter,
        name: a.name,
        active: a.active,
        dimension: a.dimension,
        type: a.type,
        branch: a.branch,
        validfrom: a.validfrom,
        sequenceno: a.sequenceno,
      };
      console.log(data);
      dispatch(add_business_channel(data));
    } else {
      const data = {
        id: activeData.id,
        active: a.active,
        costcenter: a.costcenter,
        name: a.name,
        dimension: a.dimension,
        type: a.type,
        branch: a.branch,
        validfrom: a.validfrom,
        sequenceno: a.sequenceno,
      };
      dispatch(edit_business_channel(data));
    }
  };
  useEffect(() => {
    dispatch(list_business_channel(""));
    dispatch(list_branch_master(""));
    dispatch(raise_api_call_list_general_setting(""));
    if (addBusinessChannel.isSuccess) {
      dispatch(add_business_channel_isSuccess(""));
      setOpen(false);
      resetForm();
    }
    if (editBusinessChannel.isSuccess) {
      dispatch(edit_business_channel_isSuccess(""));
      setOpen(false);
      resetForm();
      setEdit(false);
    }
    if (addBusinessChannel.api_completed) {
      setResponsePopup(true);
      dispatch(add_business_channel_api_complete(false));
    }
    if (editBusinessChannel.api_completed) {
      setResponseEdit(true);
      dispatch(edit_business_channel_api_complete(false));
      setResponsePopup(true);
    }
  }, [addBusinessChannel, editBusinessChannel]);

  const handleBack = () => {
    dispatch(clearGroupDataData());
    setShowBack(false);
    setTitleContext("Business Channel");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      dispatch(clearGroupDataData());
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (activeData?.name) {
      setShowBack(true);
    }
  }, [activeData]);

  useEffect(() => {
    setTitleContext(activeData.name ?? "Business Channel");
  }, [activeData]);

  // mainTable data
  const mainTable = () => {
    const filterarr = [];
    if (business_channel_data.data.length != 0) {
      for (let i = 0; i < business_channel_data.data.result.length; i++) {
        let data = { ...business_channel_data.data.result[i] };
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];

        const valid_from = new Date(data.validfrom);
        // delete data.EffecDate;
        data.valid_from_date =
          valid_from.getDate() +
          "-" +
          monthNames[valid_from.getMonth()] +
          "-" +
          valid_from.getFullYear();
        // create on
        const created_on = new Date(data.created_on);
        // delete data.EffecDate;
        const created_date =
          created_on.getDate() +
          "-" +
          monthNames[created_on.getMonth()] +
          "-" +
          created_on.getFullYear();
        data.created_on
          ? (data.created_on = created_date)
          : console.log("sdfdsf");

        // update on
        const updated_on = new Date(data.updated_On);
        // delete data.EffecDate;
        const update_date =
          updated_on.getDate() +
          "-" +
          monthNames[updated_on.getMonth()] +
          "-" +
          updated_on.getFullYear();
        data.updated_On
          ? (data.updated_On = update_date)
          : console.log("sdfdsf");

        filterarr.push(data);
      }
    }
    // filterarr.filter((e) => delete e.id);
    // filterarr.filter((e) => delete e.active);
    // filterarr.filter((e) => delete e.created_by);
    // filterarr.filter((e) => delete e.updated_by);

    return (
      <Fragment>
        <div className="content_container">
          <div
            className={`mini_side_container`}
            style={{
              display: isMobile && activeData.id ? "none" : "initial",
            }}
          >
            <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
              Business Channel
            </h5>

            <div className="side_search_container">
              <TextField
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                placeholder="Search"
                className="side_search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchImg} alt="search" width="20px" />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: "0px",
                    height: "45px",
                  },
                }}
              />
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  dispatch(list_business_channel(""));
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "arrows-rotate"]}
                />
              </Button>

              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  handleClickOpen();
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "add"]}
                />
              </Button>
            </div>

            <div className="side_content_container">
              {filterarr
                .filter((item: any) => {
                  return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(search.toLowerCase());
                })
                .map((e: any, key: number) => {
                  if (business_channel_data.isFirst && key === 0) {
                    dispatch(business_channel_is_first(""));
                  }
                  return (
                    <div
                      key={key + 1}
                      onClick={(a) => {
                        setActivePartner(key);
                        dispatch(addGroupDataData(e));
                      }}
                      className={`side_content_card`}
                    >
                      <div
                        className={`side_content_mini_card ${
                          e.id === activeData.id ? "active" : ""
                        }`}
                      >
                        <div className="f4 title">{e.name}</div>
                        <div className="side_content_footer">
                          <h4 className="f4 subtitle">{e.type}</h4>
                          {/* <h4>{e.status}</h4> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            className={`mini_content_container`}
            style={{
              display: isMobile && !activeData.id ? "none" : "initial",
            }}
          >
            {Object.keys(activeData).length === 0 ? (
              <div className="not_found_container">
                <img src={DataNotFound} alt="" />
                Please Select Any One Business Channel
              </div>
            ) : (
              <Fragment>
                <div className="content_header justify-content-end">
                  <div className="btns">
                    {Object.keys(activeData).length != 0 && activeData.name ? (
                      <Button
                        className="common_btn_outline"
                        disableRipple
                        onClick={() => {
                          setEdit(true);
                          setEditData(activeData);
                          handleClickOpen();
                        }}
                      >
                        Edit
                        <FontAwesomeIcon
                          icon="edit"
                          title="Edit partner onboarding"
                        />
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="scroll_content_container scroll_content_container_2">
                  <div className="grid_container">
                    <div className="detail_item">
                      <label className="f4"> Name</label>
                      <p>{activeData.name}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Cost Center</label>
                      <p>{activeData.costcenter}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4"> Type</label>
                      <p>{activeData.type}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Dimension</label>
                      <p>{activeData.dimension}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Branch</label>
                      <p>{activeData.branch}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Sequence No</label>
                      <p>{activeData.sequenceno}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Sequence Code</label>
                      <p>{activeData.sequencecode}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Active</label>
                      <p>{activeData.active ? "Active" : "InActive"}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Valid From</label>
                      <p>{activeData.valid_from_date}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Create On</label>
                      <p>{activeData.created_on}</p>
                    </div>
                    <div className="detail_item">
                      <label className="f4">Update On</label>
                      <p>{activeData.updated_On}</p>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}

            {/* <MainTable mainTableData={filterarr} nonObject={true} /> */}
          </div>
        </div>
      </Fragment>
    );
  };
  const branch_option =
    branch_master_data.data.length != 0
      ? branch_master_data.data.status
        ? branch_master_data.data.result.map((e: any) => {
            const data = { label: e.branch_name, value: e.branch_code };
            return data;
          })
        : [{ label: "No data", value: null }]
      : [{ label: "No data", value: null }];

  return (
    <Fragment>
      <div className="partner-details">
        {responsePopup ? (
          <CompletePopup
            data={responseEdit ? editBusinessChannel : addBusinessChannel}
            responsePopup={responsePopup}
            setCompletePopup={(e: any) => {
              setResponsePopup(false);
              setResponseEdit(false);
            }}
          />
        ) : (
          ""
        )}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={
            generalSettingList.isLoading || business_channel_data.isLoading
              ? true
              : false
          }
        >
          {/* <CircularProgress color="inherit" /> */}
          <img
            style={{
              height: "150px",
            }}
            src={require("../../assets/images/3.gif")}
          ></img>
        </Backdrop>

        {mainTable()}
      </div>
      <Dialog
        PaperProps={{
          style: { borderRadius: 0 },
        }}
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="dialog_header common_border_bottom">
          <h4 id="alert-dialog-title" className="f4">
            {"Add Business Channel"}
          </h4>

          <CancelIcon
            onClick={() => {
              handleClose();
            }}
          />
        </div>
        <DialogContent>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="costcenter"
                label="Cost Center"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="name"
                label="Name"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="dimension"
                label="Dimension"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="type"
                label="Type"
                handleBlur={handleBlur}
                handleChange={handleChange}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <AutoComplete
                pageOption={branch_option}
                name="branch"
                label="Branch"
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                touched={touched}
                vari={(e: any) => {
                  setFieldValue("branch", e ? e.value : "");
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className="field_item">
                <label className="f4">
                  Valid from<span>*</span>
                </label>

                <TextField
                  type="date"
                  className="custom_textfield"
                  placeholder="Address Id"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.validfrom}
                  error={touched.validfrom && errors.validfrom ? true : false}
                  helperText={
                    touched.validfrom && errors.validfrom
                      ? errors.validfrom
                      : ""
                  }
                  name="validfrom"
                />
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFiealdInput
                name="sequenceno"
                label="Sequence No"
                handleBlur={handleBlur}
                handleChange={handleChange}
                readOnly={isEdit}
                values={values}
                errors={errors}
                touched={touched}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <div className="field_item">
                <FormControlLabel
                  value={values.active}
                  control={<Checkbox checked={values.active} />}
                  label="Is Active"
                  onChange={handleChange}
                  name="active"
                  labelPlacement="end"
                />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <div className="dialog_footer">
            <Button
              disableRipple
              onClick={() => {
                handleClose();
                setEdit(false);
              }}
              className="common_btn_outline"
            >
              Cancel
            </Button>
            <Button
              className="common_btn"
              disableRipple
              onClick={() => {
                handleSubmit();
              }}
            >
              {addBusinessChannel.isLoading || editBusinessChannel.isLoading
                ? "Please Wait"
                : "Save"}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default GroupMaster;
